import { useLogger } from "@/hooks/useLogger"
import { useQueryString } from "@/hooks/useQueryString"
import { useTranslation } from "@/hooks/useTranslation"
import {
  useUpdateWorkflowOrder,
  useWorkflow
} from "@/pages/GovernancePage/applications/workflow/useWorkflow"
import { useState } from "react"
import { AutomatedActionsPageComponent } from "../../pages/AutomatedActionsPage"
import { DraggableTable } from "../DraggableTable/DraggableTable"
import { AutomatedActionsTab } from "./AutomatedActionsTab"

export const DraggableWorkflowTable: AutomatedActionsPageComponent = (
  props
) => {
  const { messageApi, messageContext } = props
  const params = useQueryString()
  const [context, { actions, loading }] = useWorkflow(params)
  const { data } = context.response || {}
  const state = useState<any[]>([])
  const { logger, EVENTS } = useLogger()
  const { t } = useTranslation()
  const updateWorkflowOrderMutation = useUpdateWorkflowOrder()
  const { t: tDragging } = useTranslation("translation", {
    keyPrefix: "settings.draggingRow"
  })
  const updateWorkflowOrder = async (workflows: any[]) => {
    const listUpdatingKey = "listUpdating"
    const listUpdatedKey = "listUpdated"

    try {
      messageApi.loading({
        key: listUpdatingKey,
        content: tDragging(listUpdatingKey),
        duration: 0
      })

      const workflowIds = workflows.map((workflow) => workflow.id)

      await updateWorkflowOrderMutation.mutateAsync({
        ordered_workflow_ids: workflowIds
      })

      messageApi.success(tDragging(listUpdatedKey))
    } catch (err: any) {
      console.error("Error updating workflow order:", err)

      if (typeof err?.data?.detail === "string") {
        return messageApi.error(err.data.detail)
      }
      messageApi.error({ content: t("error.serverError") })

      if (data) state[1](data)
    } finally {
      messageApi.destroy(listUpdatingKey)
    }
  }

  return (
    <>
      {messageContext}
      <DraggableTable
        data={data}
        state={state}
        action={updateWorkflowOrder}
        onReorderOrder={(data) =>
          logger.info(EVENTS.ANALYTIC_EVENTS.WORKFLOW.REORDER, data)
        }
      >
        <AutomatedActionsTab
          messageApi={messageApi}
          messageContext={messageContext}
          actions={actions}
          loading={loading}
          draggableDataSource={state[0]}
          t={t}
        />
      </DraggableTable>
    </>
  )
}
